const decodeHtmlEntities = (str) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = str;
  return textarea.value;
};

export const makeLinksClickable = (text) => {
  const decoded = decodeHtmlEntities(text);
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g;
  const parts = decoded.split(urlRegex);

  return parts.map((part, index) =>
    urlRegex.test(part) ? (
      <a
        key={index}
        href={part.startsWith("http") ? part : `http://${part}`}
        target="_blank"
        rel="noopener noreferrer"
        className="text-[#00ADEF] underline break-all"
      >
        {part}
      </a>
    ) : (
      part
    )
  );
};
